import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

import { MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';
import { typographyCss } from 'common/typography';

type PageHeaderProps = {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
};

export const PageHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 24px 24px 8px;
  min-height: 88px;
  border-block-end: 1px solid ${cbSemanticCssVars.borderPrimary};
  gap: 16px;

  @media (width <= ${MOBILE_BREAKPOINT}px) {
    flex-direction: column;
    align-items: stretch;
    padding: 16px 24px;
    min-height: unset;
  }
`;

const HeadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  min-height: 36px;

  @media (width <= ${MOBILE_BREAKPOINT}px) {
    min-height: 24px;
  }
`;

export const PageHeading = styled.h1`
  ${typographyCss.Heading4}
  margin: 0;

  @media (width <= ${MOBILE_BREAKPOINT}px) {
    ${typographyCss.Heading6}
  }
`;

const Subtitle = styled.span`
  ${typographyCss.Subtitle}
`;

const PageHeader = ({ title, subtitle, children }: PageHeaderProps) => {
  return (
    <PageHeaderContainer>
      <HeadingContainer>
        <PageHeading>{title}</PageHeading>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </HeadingContainer>
      {!!children && <div>{children}</div>}
    </PageHeaderContainer>
  );
};

export default PageHeader;
